window.addEventListener("load", function () {

    var $bannerNumber = $('#cfl-ms-25-feature .banner-number');

    function updateBannerNumber(realIndex) {
        $bannerNumber.removeClass(function (i, cls) {
            return (cls.match(/banner-number-\d+/) || []).join(' ');
        });
        $bannerNumber.addClass('banner-number-' + (realIndex + 1));
    }

    var swiper = new Swiper(".mySwiper", {
        //initialSlide: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        spaceBetween: -150,
        speed: 600,
        loopedSlides: 5,
        observer: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        on: {
            slideChange: function () {
                updateBannerNumber(this.realIndex);
            },
        },
    });

    updateBannerNumber(0);
});
